module.exports = __webpack_public_path__ + "img/IMG-20200227-WA0301.0b995f13.jpg";